module.exports = __webpack_public_path__ + "static/Apple iPhone 8 Space Grey-1cb47e50cc4ebd7622dd6239e5428b53.webp";